import { create } from "zustand";
// import { persist, createJSONStorage } from "zustand/middleware";

type LoginAttemptsState = {
  loginAttempts: number;
};

type LoginAttemptsAction = {
  setLoginAttempts: (loginAttempts: number) => void;
  clearStoreLoginAttempts: () => void;
};

const initialLoginAttempts: LoginAttemptsState = {
  loginAttempts: 3,
};

export const useLoginAttemptsStore = create<
  LoginAttemptsState & LoginAttemptsAction
>()(
  // persist(
  (set) => ({
    ...initialLoginAttempts,
    setLoginAttempts: (loginAttempts: number) => set(() => ({ loginAttempts })),
    clearStoreLoginAttempts: () => set({ ...initialLoginAttempts }),
  })
  // {
  //   name: "login-attempts",
  //   storage: createJSONStorage(() => localStorage),
  // }
);
// );
